/* eslint-disable */
import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import moment from 'moment'
import { Link } from 'react-router-dom'
import Pagination from 'components/shared/pagination/simple'
import Table from 'components/shared/table/table'
import THead from 'components/shared/table/table-header'
import TBody from 'components/shared/table/table-body'
import TRow from 'components/shared/table/table-row'
import TCol from 'components/shared/table/table-column'
import TableLoader from 'components/shared/loader/table'
import passportActions from 'actions/passport/actions'
import ModalHandler from 'components/shared/modal/modal-handler'
import QuestionModal from 'components/shared/modals/question'
import BookingMembersModal from 'components/shared/modals/booking-members'

const PassportBookings = ({
  userId,
  fetchPassportBookings,
  fetchBookingMembers,
  fetching,
  fetchingMembers,
  ownerBookings,
  guestBookings,
  bookingMembers,
  passportCancel
}) => {
  const cancelButton = useRef()
  const [cancelId, setCancelId] = useState(null)
  const [memberBookingId, setMemberBookingId] = useState(null)

  useEffect(() => {
    fetchPassportBookings({ userId, page: ownerBookings.page, limit: ownerBookings.limit });
  }, [])

  useEffect(() => {
    if (memberBookingId) {
      fetchBookingMembers({ id: memberBookingId })
    }
  }, [memberBookingId])

  const isMoreThan24 = (date) => {
    const bookingDate = moment(date);
    const bookingDateTime = moment('9:00', 'HH:mm');

    bookingDate.set({
      hour: bookingDateTime.get('hour'),
      minute: bookingDateTime.get('minute'),
      second: bookingDateTime.get('second'),
    });
    const now = moment(new Date());

    const diff = moment.duration(bookingDate.diff(now)).asHours();

    return diff > 24;
  }

  const handleCancel = (id) => {
    setCancelId(id)
    cancelButton.current.click()
  }

  return (
    <>
      <ModalHandler title={(<button ref={cancelButton} className="hidden">Cancel passport</button>)} className="">
        {({ toggle }) => (
          <QuestionModal
            confirmTitle={'Yes, cancel my booking'}
            cancelTitle={'No'}
            cancelClass="mx-2 py-2 border border-primary-orange text-primary-orange text-sm w-48 rounded font-semibold"
            confirmClass="btn-primary mx-2 w-48 py-2 border border-primary-orange text-sm rounded font-semibold"
            actionClass="flex justify-center items-center py-5"
            onClose={toggle}
            onClickYes={() => {
              passportCancel(cancelId)
              toggle()
            }}>
            <div className="flex flex-row-reverse">
              <i onClick={toggle} className="fa fa-times py-3 px-4 cursor-pointer text-gray-600" aria-hidden="true"></i>
            </div>
            <div className="px-10 py-2">
              <p className="text-lg font-semibold">Cancel your booking?</p>
              <p className="my-3 font-thin text-sm">You will be able to rebook this space when you cancel your booking.</p>
            </div>
          </QuestionModal>
        )}
      </ModalHandler>

      <div className="shadow-md bg-white m-5 p-5">
        <h3 className="text-lg font-semibold">My Booking</h3>
        <div className="admin-amenities-list-table mt-5">
          {fetching ? (
            <TableLoader limit={ownerBookings.limit} />
          ) : (
            <Table classes="w-full border-collapse">
              <THead classes="text-xs border-b">
                {ownerBookings.headers.map((header, key) => (
                  <TCol classes="pl-0 p-3 text-primary-lightgray" key={key}>
                    {header.name}
                  </TCol>
                ))}
              </THead>
              <TBody classes="tbody">
                {ownerBookings.list.map((item, key) => {
                  const isActive = ['booked', 'confirmed'].includes(item.status)
                  return (
                    <TRow classes="border-b text-xs font-normal hover:bg-gray-100" key={key}>
                      <TCol classes="pl-0 p-3">{item.bookingDate}</TCol>
                      <TCol classes="pl-0 p-3 text-primary-orange" width="50%">
                        <Link target="_blank" to={item.spaceUrl}>{item.space}</Link>
                      </TCol>
                      <TCol
                        classes={`pl-0 p-3 uppercase ${isActive ? 'text-secondary-green' : 'text-action-danger'}`}
                      >
                        {item.status}
                      </TCol>
                      <TCol classes="pl-0 p-3">
                        {item.status === 'booked' && isMoreThan24(item.bookingDate) && (
                          <span
                            className="underline text-primary-lightgray hover:text-primary-darkgray cursor-pointer"
                            onClick={() => {
                              handleCancel(item.id)
                            }}
                          >
                            Cancel
                          </span>
                        )}
                      </TCol>
                    </TRow>
                  )
                })}
              </TBody>
            </Table>
          )}
        </div>
        <div className="flex flex-row-reverse mt-10">
          <Pagination
            page={ownerBookings.page}
            lastPage={ownerBookings.lastPage}
            total={ownerBookings.total}
            limit={ownerBookings.limit}
            prevClick={value => fetchPassportBookings({ userId, ...value })}
            nextClick={value => fetchPassportBookings({ userId, ...value })}
          />
        </div>
      </div>

      {guestBookings.list.length > 0 && (
        <div className="shadow-md bg-white m-5 p-5">
          <h3 className="text-lg font-semibold">Booking of Members</h3>
          <div className="admin-amenities-list-table mt-5">
            {fetching ? (
              <TableLoader limit={guestBookings.limit} />
            ) : (
              <Table classes="w-full border-collapse">
                <THead classes="text-xs border-b">
                  {guestBookings.headers.map((header, key) => (
                    <TCol classes="pl-0 p-3 text-primary-lightgray" key={key}>
                      {header.name}
                    </TCol>
                  ))}
                </THead>
                <TBody classes="tbody">
                  {guestBookings.list.map((item, key) => {
                    const isActive = ['booked', 'confirmed'].includes(item.status)

                    return (
                      <TRow classes="border-b text-xs font-normal hover:bg-gray-100" key={key}>
                        <TCol classes="pl-0 p-3">{item.bookingDate}</TCol>
                        <TCol classes="pl-0 p-3 text-primary-orange" width="50%">
                          <Link target="_blank" to={item.spaceUrl}>{item.space}</Link>
                        </TCol>
                        <TCol
                          classes={`pl-0 p-3 uppercase ${isActive ? 'text-secondary-green' : 'text-action-danger'}`}
                        >
                          {item.status}
                        </TCol>
                        <TCol classes="pl-0 p-3 text-center">
                          <ModalHandler title={(<button className="text-blue-400" onClick={() => setMemberBookingId(item.id)}>{String(item.pax).padStart(2, '0')}</button>)} className="">
                            {({ toggle }) => (
                              <BookingMembersModal fetching={fetchingMembers} onClose={toggle} list={bookingMembers.list} bookingDate={bookingMembers.bookingDate} space={bookingMembers.space} spaceUrl={bookingMembers.spaceUrl} numberOfBookings={bookingMembers.numberOfBooking} status={bookingMembers.status} />
                            )}
                          </ModalHandler>
                        </TCol>
                      </TRow>
                    )
                  })}
                </TBody>
              </Table>
            )}
            {fetching && <TableLoader limit={guestBookings.limit} />}
          </div>
          <div className="flex flex-row-reverse mt-10">
            <Pagination
              page={guestBookings.page}
              lastPage={guestBookings.lastPage}
              total={guestBookings.total}
              limit={guestBookings.limit}
              prevClick={value => fetchPassportBookings({ userId, guestPage: value.page, guestLimit: value.limit })}
              nextClick={value => fetchPassportBookings({ userId, guestPage: value.page, guestLimit: value.limit })}
            />
          </div>
        </div>
      )}
    </>
  )
}

PassportBookings.propTypes = {
  userId: PropTypes.number.isRequired,
  fetchPassportBookings: PropTypes.func.isRequired,
  ownerBookings: PropTypes.object.isRequired,
  guestBookings: PropTypes.object.isRequired,
  fetching: PropTypes.bool.isRequired,
  passportCancel: PropTypes.func
}

const mapStateToProps = ({ auth, passport }) => {
  return ({
    userId: auth.user.id,
    ownerBookings: passport.bookings.owner,
    guestBookings: passport.bookings.guest,
    bookingMembers: passport.bookingMembers,
    fetching: passport.fetching,
    fetchingMembers: passport.fetchingMembers,
  })
}

const mapDispatchToProps = {
  fetchPassportBookings: passportActions.fetchPassportBookings,
  fetchBookingMembers: passportActions.fetchBookingMembers,
  passportCancel: passportActions.passportCancel,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PassportBookings)
